var render, staticRenderFns
import script from "./SkeletonLoader.vue?vue&type=script&lang=tsx&"
export * from "./SkeletonLoader.vue?vue&type=script&lang=tsx&"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=309884e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports